import Work1 from '../../assets/work-1-1.svg';
import Work2 from '../../assets/work-2-1.svg';
import Work3 from '../../assets/work-3-1.svg';
import Work4 from '../../assets/work-4-1.svg';
import Work5 from '../../assets/work-5-1.svg';
import Work6 from '../../assets/work-6-1.svg';

// eslint-disable-next-line no-sparse-arrays
const Menu = [
	{
		id: 1,
		image: Work1,
		title: 'bloom logo concept',
		category: 'Logo Design',
		link: 'https://www.instagram.com/p/DGNpqQLvdj7/?img_index=1',
	},
	{
		id: 2,
		image: Work2,
		title: 'Foodio - Web App',
		category: 'Development',
		link: 'https://my-restaurant-app-lovat.vercel.app/',
	},
	{
		id: 3,
		image: Work3,
		title: 'Whiskas - Web & Mobile App Design',
		category: 'UI/UX Design',
		link: 'https://www.behance.net/gallery/220121555/Whiskas-Web-Mobile-App-Design',
	},
	,
	{
		id: 4,
		image: Work4,
		title: 'organica logo concept',
		category: 'Logo Design',
		link: 'https://www.instagram.com/p/DGQND84PMAe/?img_index=2',
	},
	,
	{
		id: 5,
		image: Work5,
		title: 'Coffero - Web App',
		category: 'Development',
		link: 'https://my-coffee-app-ten.vercel.app/',
	},
	,
	{
		id: 6,
		image: Work6,
		title: 'StepTrends - Web Design',
		category: 'UI/UX Design',
		link: 'https://www.behance.net/gallery/220640143/StepTrends-Ecommerce-Web-Design',
	},
];

export default Menu;
